var _defs, _rect, _rect2, _rect3, _path, _path2, _line, _line2, _line3, _line4, _line5, _circle, _circle2, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcess04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 800",
    width: 1200,
    height: 800,
    role: "img",
    "aria-label": "Abstract illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gprocess04",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2F6560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163936"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wprocess04",
    cx: 0.2,
    cy: 0.1,
    r: 0.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#83ADA9",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83ADA9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "oprocess04",
    cx: 0.85,
    cy: 0.85,
    r: 0.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF4804",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4804",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "#F5F8F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#wprocess04)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#oprocess04)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 220 640 C 470 630 660 480 860 190",
    fill: "none",
    stroke: "#FF4804",
    strokeOpacity: 0.9,
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 220 640 C 470 630 660 480 860 190 L 860 640 Z",
    fill: "url(#gprocess04)",
    fillOpacity: 0.16
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 660,
    x2: 260,
    y2: 640,
    stroke: "#548A85",
    strokeOpacity: 0.35,
    strokeWidth: 1.6,
    strokeDasharray: "3 9"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 410,
    y1: 660,
    x2: 410,
    y2: 618,
    stroke: "#548A85",
    strokeOpacity: 0.35,
    strokeWidth: 1.6,
    strokeDasharray: "3 9"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 660,
    x2: 560,
    y2: 596,
    stroke: "#548A85",
    strokeOpacity: 0.35,
    strokeWidth: 1.6,
    strokeDasharray: "3 9"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 710,
    y1: 660,
    x2: 710,
    y2: 574,
    stroke: "#548A85",
    strokeOpacity: 0.35,
    strokeWidth: 1.6,
    strokeDasharray: "3 9"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 660,
    x2: 860,
    y2: 552,
    stroke: "#548A85",
    strokeOpacity: 0.35,
    strokeWidth: 1.6,
    strokeDasharray: "3 9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 860,
    cy: 190,
    r: 34,
    fill: "#FF4804"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 860,
    cy: 190,
    r: 66,
    fill: "none",
    stroke: "#FF4804",
    strokeOpacity: 0.35,
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 660,
    x2: 1000,
    y2: 660,
    stroke: "#548A85",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess04);
export default __webpack_public_path__ + "static/media/process-04.6479b26dc023b5ceba3fb0493b6b1adf.svg";
export { ForwardRef as ReactComponent };